import { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { settingsAPI } from './api';

const PrefsContext = createContext(null);

export function PreferencesProvider({ children }) {
  const [prefs, setPrefs] = useState({ show_tooltips: true });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    settingsAPI.get()
      .then(r => {
        const d = r.data;
        setPrefs(prev => ({
          ...prev,
          show_tooltips: d.show_tooltips !== false,
        }));
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  const updatePref = useCallback(async (key, value) => {
    setPrefs(prev => ({ ...prev, [key]: value }));
    try { await settingsAPI.updatePreferences({ [key]: value }); }
    catch { setPrefs(prev => ({ ...prev, [key]: !value })); }
  }, []);

  const setPref = useCallback((key, value) => {
    setPrefs(prev => ({ ...prev, [key]: value }));
  }, []);

  return (
    <PrefsContext.Provider value={{ ...prefs, updatePref, setPref, loading }}>
      {children}
    </PrefsContext.Provider>
  );
}

export function usePreferences() {
  const ctx = useContext(PrefsContext);
  if (!ctx) return { show_tooltips: true, updatePref: () => {}, loading: false };
  return ctx;
}
